import React, { useState, useEffect } from "react";
import { useQuery } from "react-query";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
} from "recharts";
import { getEnpointTrack } from "../services/chart.service";

const Chart = () => {

  const [statusCounts, setStatusCounts] = useState({});
  const [teachers, setTeachers] = useState({});
  const [dataTokens, setDataTokens] = useState([]);
  const [totalUserTokens, setTotalUserTokens] = useState(0);
  const [totaPetitions, setTotaPetitions] = useState(0);
  const [totalUserPetitions, setTotalUserPetitions] = useState(0);

  const { data: endpointTrackList } = useQuery(
    "endpoint-track",
    getEnpointTrack,
    { refetchOnMount: false }
  );

  const sumTokensByTeacher = (data) => {
    return data.reduce((acc, curr) => {
      if (curr.status_code === 200) {
        const teacherName = curr.teacher.email;
        acc[teacherName] = (acc[teacherName] || 0) + curr.total_tokens;
      }
      return acc;
    }, {});
  };

  const groupByTeacher = (data) => {
    const grouped = {};

    data.forEach((item) => {
      const teacherName = item.teacher.email;
      if (grouped[teacherName]) {
        grouped[teacherName]++;
      } else {
        grouped[teacherName] = 1;
      }
    });
    const result = Object.entries(grouped).map(([teacher, count]) => {
      return {
        teacher,
        count,
      };
    });

    // Ordenar por la cantidad de registros de mayor a menor
    result.sort((a, b) => b.count - a.count);

    return result;
  };

  useEffect(() => {
    if (endpointTrackList) {
      const counts = endpointTrackList.reduce((acc, item) => {
        if (item.status_code === 200) {
          acc["200"] = (acc["200"] || 0) + 1;
        } else if (item.status_code === 429) {
          acc["429"] = (acc["429"] || 0) + 1;
        }
        return acc;
      }, {});

      const statusArray = Object.keys(counts).map((key) => ({
        statusCode: key,
        count: counts[key],
      }));
      setStatusCounts(statusArray);
      const teachersGroup = groupByTeacher(endpointTrackList);
      setTeachers(teachersGroup);

      const tokenSums = sumTokensByTeacher(endpointTrackList);
      const tokensArray = Object.keys(tokenSums).map((teacher) => ({
        teacher,
        totalTokens: tokenSums[teacher],
      }));
      setDataTokens(tokensArray);
      const totalUt = tokensArray ? tokensArray.reduce((acc, value) => acc + value.totalTokens,0): 0;
      const totaP = statusArray ? statusArray.reduce((acc, value) => acc + value.count,0): 0;
      const totalUP = teachersGroup ? teachersGroup.reduce((acc, value) => acc + value.count,0): 0;
      setTotalUserTokens(totalUt);
      setTotaPetitions(totaP);
      setTotalUserPetitions(totalUP);
    }
  }, [endpointTrackList]);

  return (
    <div
      style={{
        backgroundColor: "white",
        overflow: "scroll",
        padding: 10,
      }}
    >
      <div style={{ padding: 5, fontWeight: "bold", fontSize: 14 }}>Numero de usuarios al dia : {teachers?.length}</div>
      <div style={{ padding: 5, fontWeight: "bold", fontSize: 14 }}>
      Número de tokens por usuario - Total {totalUserTokens} Tokens
      </div>
      <BarChart
        width={1500}
        height={300}
        data={dataTokens}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="teacher" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="totalTokens" fill="#d88484" />
      </BarChart>
      <div style={{ padding: 5, fontWeight: "bold", fontSize: 14 }}>
      Número de peticiones por usuario - Total: {totalUserPetitions} Peticiones
      </div>
      <BarChart
        width={1500}
        height={300}
        data={teachers}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="teacher" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="count" fill="#8884d8" />
      </BarChart>
      <div style={{ padding: 5, fontWeight: "bold", fontSize: 14 }}>
        Peticiones exitosas y fallidas (200 = Exitosa - 429 = Fallida Rate Limit) - Total {totaPetitions} Peticiones
      </div>
      <BarChart width={600} height={300} data={statusCounts}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="statusCode" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="count" fill="#82ca9d" />
      </BarChart>
    </div>
  );
};

export default Chart;
